const mutations = {
  SET_STATUS_CART_LOADING: (state, status) => {
    state.cartLoading = status
  },

  SET_CURRENT_STEP: (state, step) => {
    state.currentStep = step
  },

  SET_STATUS_GLOBAL_LOADING: (state, status) => {
    state.globalLoading = status
  },

  SET_COLOR_THEME: (state, color) => {
    if (!state.theme.color) {
      state.theme.color = color
    }
  },

  SET_IMAGE: (state, image) => {
    state.theme.image = image
  },
  SET_PAYMENT_CARD: (state, paymentCard) => {
    localStorage.setItem('paymentCard', JSON.stringify(paymentCard))
    state.paymentCard = paymentCard
  },
  SET_DISABLED_STATE_PAYMENT: (state, disabledStateBtn) => {
    state.disabledStateBtn = disabledStateBtn
  },

  SET_CART_HASH: (state, cartHash) => {
    let localCartHash = cartHash
    if (Object.keys(cartHash).length === 0 && window.sessionStorage.getItem('cartHash')) {
      localCartHash = JSON.parse(window.sessionStorage.getItem('cartHash'))
    } else if (Object.keys(cartHash).length > 0) {
      window.sessionStorage.setItem('cartHash', JSON.stringify(localCartHash))
    }
    state.cartHash = localCartHash
  },

  SET_CUSTOMER: (state, customer) => {
    state.customer = customer
  },

  SET_STEPSDATA: (state, stepsData) => {
    const data = { ...state.stepsData, ...stepsData }
    state.stepsData = data
  },

  SET_STATES: (state, states) => {
    state.states = states
  },

  SET_CART: (state, cart) => {
    if (cart.freights) {
      cart.freights = cart.freights.sort((current, next) => {
        const currentValue = parseFloat(current.value)
        const nextValue = parseFloat(next.value)

        if (currentValue === nextValue) {
          return 0
        }

        return currentValue < nextValue ? -1 : 1
      })
    }
    state.cart = cart
  },
  SET_PAYMENT_BILLET: (state, billet) => {
    localStorage.setItem('paymentBillet', JSON.stringify(billet))
    state.cart.payment = billet
  },
  SET_PAYMENT_PIX: (state, pix) => {
    localStorage.setItem('paymentPix', JSON.stringify(pix))
    state.cart.payment = pix
  },
  SET_STORE_ID: (state, storeId) => {
    state.store_id = storeId
  },

  SET_PAYMENT_TYPE: (state, paymentType) => {
    state.payment_type = paymentType
  },

  SET_ENABLE_DISABLE_ADD_REMOVE_QUANTITY_BUNDLE(state, status) {
    state.disebleOrEnableAddRemove = status
  },

  SET_PIXELS(state, pixels) {
    state.pixels = pixels
  },

  SET_UPSELL_HASH: (state, upsellHash) => {
    state.upsell_hash = upsellHash
  },

  SET_CUSTOMER_DOCUMENT_NUMBER: (state, document) => {
    state.cart.customer.document_number = document
  },
}

export default mutations
